/**
 * @class
 * @param {Array.<DR.roadgames.struct.Pic>} par
 * @extends mkE.Base
 */
T.GalleryBlock = Class(
	/**
	 * @lends {T.GalleryBlock#}
	 */
	{
		PREVIEW_IMAGES: 4,

		/** @type {Array.<DR.roadgames.struct.Pic>} */
		images: null,
		/**
		 *
		 * @param {Array.<DR.roadgames.struct.Pic>} images
		 * @param {{overlay:Object,isStatic:Boolean}} par
		 * @private
		 */
		__construct( images, par ) {
			this.images = images;
			const els = [];
			const remainingImages = this.images.length - this.PREVIEW_IMAGES;
			let classNames = ['gallery_block'];
			if( this.PREVIEW_IMAGES >= this.images.length ) {
				classNames.push('layout-' + this.images.length);
			}

			for( let i = 0; i <= this.PREVIEW_IMAGES; i++ ) {
				const image = this.images[i];
				if( !image ) {
					continue;
				}
				let el = {
					tag: 'div',
					className: 'item',
					style: {
						backgroundImage: `url('${image.image.medium}')`
					}
				};
				if( !par.isStatic ) {
					el.tag = 'a';
					el.onclick = this.openGallery.bind(this, i);
				}
				if( !i && par.overlay ) {
					el.els = [par.overlay];
				}
				if( i >= this.PREVIEW_IMAGES && remainingImages > 1 ) {
					el.els = [{
						tag: 'span',
						text: `+${remainingImages}`
					}];
				}
				els.push(el);
			}

			this.node = mkE({
				tag: 'div',
				className: classNames.join(' '),
				els: els
			});
		},

		openGallery( index ) {
			let images = [];
			for( let i = 0; i < this.images.length; i++ ) {
				const image = this.images[i];
				images.push(image.image.original);
			}
			T.Popup.Gallery.open(images, index);
		}
	},
	mkE.Base
);